import { render } from "./DetailActionDropdown.vue?vue&type=template&id=7960daa6"
import script from "./DetailActionDropdown.vue?vue&type=script&lang=js"
export * from "./DetailActionDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DetailActionDropdown.vue"]])

export default __exports__